export default function Hero() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ab45ee77259c25964848ba9b0d1078ff.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center w-full">
        <div className="space-y-8">
          {/* Main Headline */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
            Turn Your Contracting Business Into a{' '}
            <span className="text-red-500 relative inline-block">
              Million Dollar Empire
              <div className="absolute -bottom-2 left-0 right-0 h-1 bg-red-500/50"></div>
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            We help home service contractors dominate their local market with cutting-edge digital marketing, AI automation, and proven growth strategies.
          </p>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-8 pt-6">
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-red-500 text-xl"></i>
                ))}
              </div>
              <span className="text-white font-semibold">4.9/5 Rating</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-trophy-fill text-red-500 text-2xl"></i>
              <span className="text-white font-semibold">500+ Contractors Served</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-line-chart-fill text-red-500 text-2xl"></i>
              <span className="text-white font-semibold">$50M+ Revenue Generated</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-red-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-red-600 transition-all hover:shadow-2xl hover:shadow-red-500/50 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Get Your Free Marketing Audit
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white/20 transition-all border-2 border-white/30 hover:border-white/50 whitespace-nowrap cursor-pointer"
            >
              Explore Our Services
            </button>
          </div>

          {/* Scroll Indicator */}
          <div className="pt-16 animate-bounce">
            <i className="ri-arrow-down-line text-white text-3xl opacity-70"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
